import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { VaultdnsAccessService } from './vaultdns-access.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { constants } from './../../shared/common/contants';
import { Radiobutton } from 'src/app/shared/common/Radiobutton';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { duration } from 'moment';

@Component({
    selector: 'app-vault-dnsaccess',
    templateUrl: './vault-dnsaccess.component.html',
    styleUrls: ['./vault-dnsaccess.component.scss'],
    standalone: false
})
export class VaultDNSAccessComponent implements OnInit {

  validations_form: UntypedFormGroup;
  insertData: any = [];
  validation_messages
  columnDefs
  defaultColDef
  backgroundColorScreen = "";
  buttonColor = "";
  rowClassRules
  grid
  components: any;
  userGrid
  companyDetails: any = []
  userObject: any = []
  rowSelection
  companyId: any
  dnsName: any = []
  vaultDnsAccessName: any = []
  finalvaultdata:any=[]
  fieldsData: any = [];
  selectedDnsNames;
  onRowSelectionForDNSNames;
  dnsData: any = [{ "defaultinstance": "", "tenantid": "", "status": "", "companyid": "", "vaultconfigmstrid": "", "userid": "" }];
   bindedDnsData:any=[];
   temp: any = [];
   dnsNameresult:any=[]
   vaultid:any
   removeaccess:any=[];
   selectedCompanyid;
   selectedUserid;
   userid;
   companyid;
   tenantid;

   selectedUsername;
   selectedCompname;
   getUsername(userObject){
    
    this.selectedUsername=userObject.username;
    
   }
   getCompanyName(compObject){
    
    this.selectedCompname=compObject.compname;
    console.log(this.selectedCompname);
   
   
   
   
   }

  constructor(
    private validation: validationmethod,
    private msg: ErrorMessages,
    private fb: UntypedFormBuilder,
    private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService,
    private linkservice: ReportlinksserviceService,
    private constants: constants,
    private service: VaultdnsAccessService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService

  ) {
    this.components = {
      buttonRenderer: Radiobutton,
      actionCheckBox: ActionCheckBox,
    }
    this.validation_messages = this.msg.dnsConfiguration;
  }

  formValidation() {

    this.validations_form = new UntypedFormGroup({
      compname: new UntypedFormControl('', [Validators.required]),
      username: new UntypedFormControl('', [Validators.required]),
    
     
      
    });
    
  }
  ngOnInit() {
    this.columnDefs = [{
      headerName: 'Select',
      filter: false, cellRenderer: 'actionCheckBox',
      pinned: 'left',
      lockPinned: true,
      cellRendererParams: {
        updateCheckbox: this.CheckBox.bind(this)
      }, width: 100
    },

    { headerName: 'DNS Name', headerTooltip: 'dnsname', tooltipValueGetter: (params) => 'DNS Name : ' + params.value, field: 'dnsname', width: 500 },
    {
      headerName: 'Default', filter: false, cellRenderer: 'buttonRenderer',
      pinned: 'right',
      lockPinned: true,
      cellRendererParams: {
        selectOption: this.Radiobutton.bind(this)
      }, width: 100
    }

    ]

    this.onRowSelectionForDNSNames = 'multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.formValidation();
    this.lookupVaultGroup();

  }

  //calling service and binding the data to the company name drpdown
  async lookupVaultGroup() {
    this.userObject=[];
    let tableName = "company";
    this.companyDetails=[];
    this.selectedCompanyid="";
    let res = await this.commonService.retrieveRecordService(tableName);
    console.log(res)
    this.companyDetails = res
   
  }

  // binding the data to the User name dropdown
  async valutGroupcheck(e) {
    console.log(e.value)
    
    this.userObject=[];
    this.selectedUserid="";
    this.userGrid.api.setGridOption('rowData', []);
    
    let response = await this.commonService.retrieveSingleRecordService("users", "companyid", e.value);
    console.log(response);
   
    this.userObject = response;
   
    this.validations_form.get('username').markAsUntouched();

  }

  //calling service and retrieving the data for gird
  async dnsGroupcheck(e) {
    console.log(e.value);
     this.dnsNameresult = await this.service.retrieveDnsName(e.value);
     
    console.log(this.dnsNameresult)
    this.dnsName = this.dnsNameresult;
    this.onGridReadyForDNSName(this.userGrid) 
    // console.log(this.dnsName.length);
    // this.bindedDnsData=[];
    // for(let i=0;i<this.dnsName.length;i++){
    //   if(this.dnsName[i].defaultinstance===null ){
    //      console.log(this.dnsName[i]);
    //     }
    //   else{
    //  this.bindedDnsData.push(this.dnsName[i]);
    //  console.log(this.dnsName[i])
    //  console.log(this.bindedDnsData);
    // this.selectcheckedfield()
    //  }
    //}
   
  }

  // selectcheckedfield() {
  //   console.log(this.userGrid.api)
  //   console.log(this.bindedDnsData.length);
  //   for(let k=0; k<this.bindedDnsData.length; k++){
  //     console.log(this.bindedDnsData[0]);
  //   this.userGrid.api.forEachNode(node=> {
  //     console.log(node.data.dnsname)
  //     console.log(this.bindedDnsData[k].dnsname)
  //     if(node.data.dnsname===this.bindedDnsData[k].dnsname){
  //       node.setSelected(true);
  //     }
  //   });
  // }
  // }


  //binding the data to the grid
  onGridReadyForDNSName(params) {
    this.selectedDnsNames = [];
    this.userGrid = params;
    this.vaultDnsAccessName = this.dnsName;
    console.log(this.vaultDnsAccessName)
    for(let v=0;v<this.vaultDnsAccessName.length;v++){
      
    this.userid = this.vaultDnsAccessName[0].userid;
    this.companyid = this.vaultDnsAccessName[0].companyid;
    this.tenantid = this.vaultDnsAccessName[0].tenantid;
      if(this.vaultDnsAccessName[v].defaultinstance==="1"){
        this.vaultDnsAccessName[v].defaultinstance = true;
      }else if(this.vaultDnsAccessName[v].defaultinstance==="0"){
        this.vaultDnsAccessName[v].defaultinstance = null;
      }
      else{
        this.vaultDnsAccessName[v].defaultinstance = null;
      }
    }
    
    this.userGrid.api.setGridOption('rowData', this.vaultDnsAccessName);

  }
  // onRowSelected() {
  

  //   this.fieldsData = this.userGrid.api.getSelectedRows();

  //   console.log(this.fieldsData);


  // }
  Radiobutton(data) {
    console.log(data.rowData);

    console.log(data.rowData.vaultconfigmstrid);
    for(let i=0;i<this.vaultDnsAccessName.length;i++){
      if(this.vaultDnsAccessName[i].vaultconfigmstrid === data.rowData.vaultconfigmstrid){
        this.vaultDnsAccessName[i].defaultinstance=true;
      }else{
        this.vaultDnsAccessName[i].defaultinstance=null;
      }
    }
    console.log(this.vaultDnsAccessName)

  }

  CheckBox(data){

    console.log(data.rowData);

  }
  

  save() {
    let matched = 0;
    let select = 0;
    this.removeaccess = [];
    this.finalvaultdata=[];
    console.log(this.fieldsData);
    
    console.log(this.vaultDnsAccessName);
    //validating grid must be selected at least one row
    console.log(this.userGrid.api.getSelectedRows().length);

        this.finalvaultdata = this.vaultDnsAccessName;
        console.log(this.vaultDnsAccessName)
        for(let i=0;i<this.vaultDnsAccessName.length;i++){
          console.log(this.vaultDnsAccessName[i].selectinstance)
      if(this.vaultDnsAccessName[i].selectinstance === false || this.vaultDnsAccessName[i].selectinstance === null){
          this.removeaccess.push(i)
        
      }else{
        select = 1;
        console.log(this.vaultDnsAccessName[i].defaultinstance)
        if(this.vaultDnsAccessName[i].defaultinstance === null){
          console.log(this.vaultDnsAccessName[i].defaultinstance)
          this.vaultDnsAccessName[i].defaultinstance = false;
        }else if(this.vaultDnsAccessName[i].defaultinstance === true){
          matched = 1;
        }
      }
    }
console.log(this.removeaccess.length)
console.log(this.vaultDnsAccessName.length)
console.log(matched)
if(matched ===1){
  this.saveData(this.vaultDnsAccessName);
  }
else if(this.vaultDnsAccessName.length!==this.removeaccess.length){
  this.snackBar.open("Please Select one of the selected DNS as default","Ok",{ duration: 5000 })

}else{
let removed = this.removeaccess.length;
let total = this.vaultDnsAccessName.length;
    for(var r=this.removeaccess.length-1;r>=0;r--){
      this.vaultDnsAccessName.splice(this.removeaccess[r],1);
    }

    if(total === removed){
      console.log("1st")
      console.log(this.userid)
      console.log(this.companyid)
      console.log(this.tenantid)
        this.dnsData[0].userid = this.userid;
        this.dnsData[0].companyid = this.companyid;
        this.dnsData[0].tenantid = this.tenantid;
        this.dnsData[0].vaultconfigmstrid = 0;
         
      
      this.saveData(this.dnsData);
    }
  }
    

    
    console.log(this.vaultDnsAccessName)
    
          
        

      
    
  }

  removeAccess(){
    for(let r=0;r<this.vaultDnsAccessName.length;r++){
      if(this.vaultDnsAccessName[r].defaultinstance === true){
        this.vaultDnsAccessName[r].defaultinstance = false;
      }
    }
  }
  saveData(finalvaultdata) {
   
    //adding additional parameter
    finalvaultdata[0].username=this.selectedUsername;
    finalvaultdata.compname=this.selectedCompname;
   
    
    this.service.insertDNSData(finalvaultdata).subscribe(response => {
      console.log(response);
      this.spinner.start();
      this.spinner.stop();
      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
      return response.error;

    });
    this.validations_form.reset();
    this.userGrid.api.setGridOption('rowData', []);
  }

}


